import React, { HTMLAttributes, PropsWithChildren } from 'react';

export function PageLeadDescription({
  children,
  ...htmlSpanAttributes
}: PropsWithChildren<HTMLAttributes<HTMLSpanElement>>) {
  return (
    <span className="page-lead__page-description" {...htmlSpanAttributes}>
      {children}
    </span>
  );
}
